import Swiper from "swiper";
import { Autoplay, Navigation } from "swiper/modules";

const calculateSwiperBeforeOffset = (containerSelector, swiperSelector) => {
  const swiper = document.querySelector(swiperSelector);
  const container = document.querySelector(containerSelector);
  let offset = 0;
  if (container) {
    const containerStyle = getComputedStyle(container);
    offset =
      parseInt(containerStyle.marginLeft) +
      parseInt(containerStyle.paddingLeft) -
      parseInt(getComputedStyle(swiper).marginLeft);
  }
  return offset;
};
const calculateSwiperAfterOffset = (containerSelector, swiperSelector) => {
  const container = document.querySelector(containerSelector);
  const swiper = document.querySelector(swiperSelector);
  let offset = 0;
  if (container) {
    const containerStyle = getComputedStyle(container);
    offset =
      parseInt(containerStyle.marginRight) +
      parseInt(containerStyle.paddingRight) -
      parseInt(getComputedStyle(swiper).marginRight);
  }
  return offset;
};

const initSwipers = () => {
  new Swiper(".swiper.swiper-carousel", {
    slidesPerView: 1.5,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    slidesPerGroup: 1,
    noSwiping: false,
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      1024: {
        slidesPerView: 4.5,
        spaceBetween: 18,
      },
    },
    modules: [Navigation, Autoplay],
  });
  new Swiper(".swiper.swiper-spotlight", {
    slidesPerView: 1.3,
    spaceBetween: 10,
    slidesOffsetBefore: calculateSwiperBeforeOffset(
      ".js-spotlight-header",
      ".swiper.swiper-spotlight"
    ),
    slidesOffsetAfter: calculateSwiperAfterOffset(
      ".js-spotlight-header",
      ".swiper.swiper-spotlight"
    ),
    allowTouchMove: true,
    grabCursor: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
      disabledClass: "hidden",
    },
    breakpoints: {
      1024: {
        slidesPerView: 3.3,
        spaceBetween: 18,
      },
      2560: {
        slidesPerView: 4.5,
        spaceBetween: 18,
      },
    },
    on: {
      resize: (swiper) => {
        swiper.params.slidesOffsetBefore = calculateSwiperBeforeOffset(
          ".js-spotlight-header",
          ".swiper.swiper-spotlight"
        );
        swiper.params.slidesOffsetAfter = calculateSwiperAfterOffset(
          ".js-spotlight-header",
          ".swiper.swiper-spotlight"
        );
        swiper.update();
      },
    },
    modules: [Navigation, Autoplay],
  });
  document.querySelectorAll(".swiper.swiper-auto").forEach((el) => {
    const { swiper } = el;
    swiper.params.slidesPerView = "auto";
    Object.entries(swiper.params.breakpoints).forEach(([key, value]) => {
      if (value.slidesPerView)
        swiper.params.breakpoints[key].slidesPerView = "auto";
    });
    swiper.update();
  });
  document.querySelectorAll(".swiper.swiper-autoplay").forEach((el) => {
    const { dataset, swiper } = el;
    swiper.params.autoplay = {
      delay: dataset.swiperDelay || 5000,
      pauseOnMouseEnter: true,
    };
    swiper.update();
    swiper.autoplay.start();
  });
};

window.addEventListener("DOMContentLoaded", initSwipers);
document.addEventListener("htmx:load", () => {
  initSwipers();
});

export default initSwipers;
